"use strict";
if (!Object.prototype.hasOwnProperty) {
    Object.prototype.hasOwnProperty = function (prop) {
        return typeof this[prop] !== "undefined";
    };
}
if (!Object.getOwnPropertyNames) {
    Object.getOwnPropertyNames = function (obj) {
        var keys = [];
        for (var key in obj) {
            if (typeof obj.hasOwnProperty !== "undefined" &&
                obj.hasOwnProperty(key)) {
                keys.push(key);
            }
        }
        return keys;
    };
}
//# sourceMappingURL=object-getownpropertynames.js.map